import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

import { useFlowContext } from '@/components/flow/hooks/useFlowContext';
import LegalLinks from '@/components/legalLinks';
import { getDisplayName } from '@/utils/strings/getDisplayName';

const VipDisclaimer = () => {
  const { brand } = useFlowContext();
  return (
    <Typography size="meta">
      Here’s the very fine print: when you check this box, you’re agreeing to
      authorize our use of information from your medical record and within your{' '}
      {getDisplayName(brand)} profile. You also grant us the right to monitor
      your public social media metrics, for performance metrics purposes.
      Subject to complete <LegalLinks.TermsOfService brand={brand} /> and{' '}
      <LegalLinks.PrivacyPolicy brand={brand} />
    </Typography>
  );
};

export default VipDisclaimer;
